module.exports = function ($) {
    var $carousel = $(this).find('.elementor-brands-carousel');
    if (!$carousel.length) {
        return;
    }

    var respondTo = 'window';

    if (elementorFrontendConfig.isEditMode) {
        respondTo = 'iframe-window';
    }

    var savedOptions = $carousel.data('slider_options'),
        defaultOptions = {
            respondTo: respondTo,
            infinite: false,
            autoplaySpeed: 4500,
            rows: savedOptions.itemsPerColumn,
            responsive: [
                {
                    breakpoint: 992,
                    settings: {
                        slidesToShow: savedOptions.slidesToShowTablet,
                        slidesToScroll: savedOptions.slidesToShowTablet
                    }
                },
                {
                    breakpoint: 576,
                    settings: {
                        slidesToShow: savedOptions.slidesToShowMobile,
                        slidesToScroll: savedOptions.slidesToShowMobile
                    }
                }
            ]
        },

        slickOptions = $.extend({}, defaultOptions, $carousel.data('slider_options'));

    $carousel.slick(slickOptions);

    if (elementorFrontendConfig.isEditMode) {
        $(window).on('changedDeviceMode', function () {
            $carousel.slick('getSlick').checkResponsive();
        });
    }
};
